module.exports = __webpack_public_path__ + "static/media/Categoria9Laboratorio.6a28fec1.jpg";